exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".health-name{font-size:18px}.health-text{font-size:15px;color:rgba(51,51,51,.8588235294);line-height:17px}.help-text{font-size:15px;line-height:17px}.health-btn .MuiButton-label{text-transform:capitalize}.yellow-highlight{background-color:#fcffc1;border:solid 1px #f6ee65}.hideShow-link{color:#007bff;cursor:pointer}.hideShow-link:hover{color:#007bff}.help-decide{background-color:#f2f2f2;margin:0 -15px 15px}.top-class{top:-60px;float:right}.active{background-color:#f2f2f2;font-size:13px}.UW-PopUp ul li.list-type{list-style-type:circle}.button-margin{margin-top:-40px !important}.div-show{display:none}.negative-margin{margin-top:-40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Product/TermLifeInsurance/PopUps/PopUps.scss
// module id = 7464
// module chunks = 101